import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useParams } from 'react-router-dom';

import { getDailyChallengeForPreview } from 'store/dailyChallenge/actions';
import { currentDailyChallengeSelector } from 'store/dailyChallenge/selectors';

import { getTranslation } from 'helpers/getTranslation';

import DailyChallengePreviewPage from './DailyChallengePreviewPage';

const DailyChallengePreviewPageContainer = () => {
  const dispatch = useAppDispatch();

  const { id: dailyChallengeId } = useParams();

  const dailyChallenge = useAppSelector(currentDailyChallengeSelector);

  const [loading, setLoading] = useState(true);
  const [previewType, setPreviewType] = useState(
    getTranslation('common.text.plugin'),
  );

  useEffect(() => {
    const _load = async () => {
      try {
        if (dailyChallengeId) {
          await dispatch(getDailyChallengeForPreview(dailyChallengeId)).unwrap();
        }
      } catch (error) {
        console.warn(error);
      }

      setLoading(false);
    };

    _load();
  }, []);

  return (
    <DailyChallengePreviewPage
      loading={loading}
      training={dailyChallenge}
      previewType={previewType}
      setPreviewType={setPreviewType}
    />
  );
};

export default React.memo(DailyChallengePreviewPageContainer) as any;
